import type { ReactNode } from "react";

type StepHeadingProps = {
  title: string;
  description?: string;
  /** Small uppercase label rendered above the title in the brand accent color. */
  eyebrow?: string;
  hint?: ReactNode;
  align?: "left" | "center";
  editablePath?: string;
};

export const StepHeading = ({
  title,
  description,
  eyebrow,
  hint,
  align = "left",
  editablePath = "headline",
}: StepHeadingProps) => (
  <header className="flex flex-col gap-3" style={{ textAlign: align }}>
    {eyebrow && (
      <span
        data-editable-path="eyebrow"
        className="text-xs font-semibold uppercase tracking-widest"
        style={{ color: "hsl(var(--brand-primary))" }}
      >
        {eyebrow}
      </span>
    )}
    <h1
      data-step-heading
      data-editable-path={editablePath}
      tabIndex={-1}
      className="m-0 text-3xl font-bold tracking-tight"
      style={{
        color: "hsl(var(--brand-bg-foreground))",
        textWrap: "pretty",
        outline: "none",
        fontFamily: "var(--brand-font-display)",
      }}
    >
      {title}
    </h1>
    {description && (
      <p
        data-editable-path="description"
        className="m-0 text-base"
        style={{
          color: "hsl(var(--hero-fg-muted))",
          textWrap: "pretty",
        }}
      >
        {description}
      </p>
    )}
    {hint && (
      <p className="m-0 text-xs" style={{ color: "hsl(var(--hero-fg-muted))" }}>
        {hint}
      </p>
    )}
  </header>
);

export default StepHeading;
